// @flow @jsx h

import maxViewportObservable from '@nrk/max-viewport-observable'
import { Component, h } from 'preact'
import Content from './Content'
import Header from './Header'
import style from './index.css'

import type { Props, Viewport } from './types'

type State = {
  muted: boolean,
  viewport: Viewport
}

class Article extends Component<Props, State> {
  viewport$: any

  constructor () {
    super()

    this.state = {
      muted: true,
      viewport: {
        width: -1,
        height: -1
      }
    }
  }

  componentDidMount () {
    this.viewport$ = maxViewportObservable.create({
      root: window
    })

    this.viewport$.subscribe({
      next: viewport => {
        this.setState({ viewport })
      }
    })
  }

  handleToggleMute = () => {
    this.setState({ muted: !this.state.muted })
  }

  render () {
    const { muted, viewport } = this.state

    return (
      <article className={style.article}>
        <Header {...this.props} viewport={viewport} />
        <Content
          {...this.props}
          muted={muted}
          viewport={viewport}
          onToggleMute={this.handleToggleMute}
        />
      </article>
    )
  }
}

export default Article



// WEBPACK FOOTER //
// ./src/v1/components/Article/index.js